import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';


export class SequenceOrder extends DexResourceModel {

    @Field(String)
    public sequenceOrderType_uuid: string = "";

    //declared already on ResourceModel
    // @Field(String)
    // public data: string | null = null;
    public sequenceData: string | null = null;

    @Field(Boolean)
    public active: boolean = false;

    @Field(Boolean)
    public rejected: boolean = false;

    constructor(data?: any) {
        super();
        this.mapData(data);
        this.sequenceData = data?.data;
    }

    public get data(): any {
        let json = super.data;

        return json;
    }
}
